import { DOWNLOAD_APK_URL, SITE_BRAND, SITE_EMAIL } from '@/config/site'

export const appInfo = {
  name: 'GB WhatsApp',
  latestVersion: 'v18.80',
  fileSize: '80 MB',
  androidVersion: 'Android 5.0+',
  fileType: 'APK',
  platform: 'Android',
  lastUpdated: 'July 2026',
  releaseMonth: 'July',
  downloadPath: DOWNLOAD_APK_URL,
}

export const apkDetails = [
  ['App Name', appInfo.name],
  ['Latest Version', appInfo.latestVersion],
  ['File Size', appInfo.fileSize],
  ['Android Version', appInfo.androidVersion],
  ['File Type', appInfo.fileType],
  ['Last Updated', appInfo.lastUpdated],
]

export const downloadDetails = [
  ['App Name', appInfo.name],
  ['File Type', appInfo.fileType],
  ['Platform', appInfo.platform],
  ['Latest Version', appInfo.latestVersion],
  ['File Size', appInfo.fileSize],
]

export const featureCards = [
  ['Custom Themes', 'Change the look of chats with themes, colors, and layouts that feel more personal.', 'CT'],
  ['Hide Online Status', 'Choose when your online presence appears, which helps when you want quieter messaging time.', 'OS'],
  ['Message Privacy Options', 'Adjust extra visibility settings for chats and profile activity, depending on the build.', 'MP'],
  ['Anti-Delete Messages', 'Some removed messages may stay visible in conversations when the feature is supported.', 'DM'],
  ['Anti-Delete Status', 'View certain status posts even if the sender removes them later.', 'DS'],
  ['Advanced Media Sharing', 'Send photos, videos, and documents with more flexible sharing controls.', 'MS'],
  ['Larger File Sharing', 'Share bigger media files than the limits usually found in the official app.', 'LF'],
  ['Chat Customization', 'Personalize conversation screens with different fonts, colors, and visual styles.', 'CC'],
  ['Font Styles', 'Give message text a different look without changing system-wide phone settings.', 'Aa'],
  ['App Lock', 'Add a separate lock for the app when you want another privacy layer.', 'AL'],
  ['Multiple Account Support', 'Use more than one WhatsApp account option on the same Android device.', 'MA'],
  ['Backup and Restore Options', 'Manage chat data more carefully when replacing or reinstalling the app.', 'BR'],
]

export const homeFaqs = [
  [
    'Where can I get the current APK file?',
    'Use the main button above or open /download/. Check the version number, file size, and Android requirement before saving the package. If your phone already has older copies in the Downloads folder, remove them so you do not open the wrong file by mistake. Be cautious with mirrors that rename packages or show a different version.',
  ],
  [
    'Why will the APK not install on my Android phone?',
    'Install failures usually come from low storage, blocked unknown-source permissions, an old Android build, or a file that did not finish saving. Free some space, allow installation for the browser or file manager that holds the package, and check the file size if something looks off. A quick restart can help when the Android installer freezes. If the phone still refuses it, look for an older file with the same name and remove it.',
  ],
  [
    'Can I move my WhatsApp chats over?',
    'Many Android users start with a local WhatsApp backup, then restore it during setup. Results vary by app build, backup method, and phone settings, so protect important conversations before switching. Do not skip the restore screen if you need old chats. If it fails, keep the backup file and try again after a clean install; cloud backups may miss some media items.',
  ],
  [
    'Does it need root access?',
    'Most builds are made for regular Android phones and do not require root access. You normally allow unknown-source installation, open the package, and finish setup inside the app. Root tools are not part of the usual process. If a file asks for them, stop and review where it came from.',
  ],
  [
    'Should I remove WhatsApp first?',
    'That depends on the package and your phone. Some devices can keep both apps, while others show a package conflict and block setup. Back up chats first, then read the Android message carefully if it asks you to remove an existing app. Do not uninstall anything until you know where the backup is stored.',
  ],
  [
    'Could my WhatsApp account be banned?',
    'Modified apps are not official WhatsApp products, so account risk is possible. No third-party resource can promise account safety. Use your own judgment, and never share login codes or private account details with unlock tools. If your account is restricted, use the official WhatsApp recovery process.',
  ],
]

export const downloadFaqs = [
  [
    'Why Is My GB WhatsApp Showing an Old Version After Download?',
    'Clear old APK files from your downloads folder and install only the latest file from this page. Opening an older saved APK can install an outdated version. After install, check the version in app settings.',
  ],
  [
    'Why Does GB WhatsApp Ask Me to Enable Unknown Sources?',
    'Android asks for this because APK files are installed outside the Google Play Store. Allow installation for your browser or file manager before you open the APK.',
  ],
  [
    'What Android Version Is Required for GB WhatsApp APK?',
    'This page lists Android 5.0+ as the basic requirement. If the install screen reports a compatibility problem, check your Android version in phone settings first.',
  ],
  [
    'How Often Is GB WhatsApp Updated to New Versions?',
    'Updates do not follow a fixed public schedule. Open the update page on this website for the newest version, release notes, and update steps.',
  ],
]

export const updateFaqs = [
  [
    'Can I update GB WhatsApp without uninstalling it?',
    'In many cases, users install the new APK over the old version. This can keep chats in place when the package supports update installation. Always backup chats before you continue.',
  ],
  [
    'Why can\'t I install the latest update?',
    'Your device may block unknown sources, lack storage space, or use an Android version that is too old. Download the APK again and check these settings before another install attempt.',
  ],
  [
    'Will updating delete my chats?',
    'An update should not delete chats in normal cases. A backup is still important before installing any new APK, especially if the install process asks you to restore data.',
  ],
  [
    'How do I know I\'m using the latest version?',
    'Open the app information or settings screen and compare the installed version with the latest version shown on this update page. If the numbers match, you are on the current listed release.',
  ],
  [
    'Can I skip an update?',
    'You can skip an update, but older versions may stop working well or miss fixes from newer releases. Checking updates regularly helps you avoid known bugs and setup issues.',
  ],
  [
    'Why isn\'t the latest version working on my phone?',
    'The APK may not match your Android version, storage space, or device settings. Confirm the file size, allow unknown sources, and restart your phone after installation if needed.',
  ],
  [
    'How often should I update GB WhatsApp?',
    'Check for updates regularly, especially when the app has login, message, or media sharing issues. Updating only when needed is fine as long as you review version details first.',
  ],
  [
    'Where can I download the newest update?',
    'Use the download button on this GB WhatsApp update page or open the main download page on this site. Both paths lead to the current APK download flow used by this website.',
  ],
]

export const updateHighlights = [
  ['Improved Privacy Options', 'Improved privacy options for users who want more control over chat settings and visibility choices.'],
  ['Better Android Compatibility', 'Better Android compatibility for supported phones and common Android versions used by many users.'],
  ['Bug Fixes', 'Bug fixes for issues reported in some previous GB WhatsApp versions, including general stability work.'],
  ['Performance Improvements', 'Performance improvements to help the app open and respond more smoothly on supported devices.'],
  ['UI Refinements', 'UI refinements that make menus, chat screens, and settings easier to read and use.'],
  ['Media Sharing Enhancements', 'Media sharing enhancements for photos, videos, and document options in everyday chats.'],
]

export const previousVersions = [
  ['v18.80', 'July listing with the file details and update notes used across the site.'],
  ['v18.70', 'Earlier release from the cycle before the July listing.'],
  ['v18.60', 'Older entry kept as a reference for version history.'],
]

export const oldVersionFaqs = [
  [
    'Can I download GB WhatsApp v18.70 or v18.60?',
    'These versions appear in the historical version list on this website. Actual download availability depends on whether a corresponding APK file is available. A version listing alone does not confirm that a download is ready.',
  ],
  [
    'Will an older GB WhatsApp version restore my deleted messages?',
    'No, not by itself. Message recovery depends on whether a suitable backup or another copy of the data exists. Installing an older version does not automatically restore deleted conversations.',
  ],
  [
    'Can I install an old version without uninstalling the current app?',
    'It depends on package compatibility and the app signing information. Android may reject an installation if the packages are incompatible. Do not uninstall the current app without first preserving important data.',
  ],
  [
    'Is an older version safer than the latest version?',
    'Not necessarily. Older builds may lack later fixes or compatibility improvements. Modified apps also carry risks that cannot be eliminated simply by choosing a particular version.',
  ],
]

export const guideCards = [
  [
    'How to Install GB WhatsApp APK on Android',
    'Review the file details, allow installs from your browser or file manager, then check the version number after setup. A useful read for first-time installation.',
    'en-download',
  ],
  [
    'How to Update GB WhatsApp Without Losing Chats',
    'Back up chats first, replace the old build when Android allows it, and check the version in app settings. Read this before replacing an older build.',
    'en-update',
  ],
  [
    'GB WhatsApp Latest Version Notes',
    'See the release notes, recent version entries, and update FAQ answers when a new package will not install cleanly.',
    'en-update',
  ],
]

// 首页各板块加长正文（A2-B1，中性语气）
export const homeCopy = {
  heroLead:
    'Find the current Android package details without digging through mirror pages. The essentials are upfront: version number, file size, Android support, setup notes, and what to check when installation fails.',
  section1: [
    'Start with the version card if you already have an older build on your phone. It lists the release number, file size, Android requirement, file type, and update month in one quick table.',
    'Phones below Android 5.0 may reject the package, and low storage can stop installation halfway. Clearing space first saves time, especially if your chats include a lot of media.',
    'Use the main file page rather than scattered APK mirrors. Unknown sources often rename packages, leave old builds online, or hide basic file notes.',
    'Let the package finish saving before opening it from Downloads or the notification panel. A partial file may look normal in your file manager but fail as soon as Android tries to install it.',
  ],
  section1Checks: [
    'Compare the listed version with the one already installed, if you have a previous build.',
    'Leave room for the package itself and for chat media after setup.',
    'Open the saved file from Downloads or from the browser notification.',
    'Remove older copies so Android does not install the wrong package.',
    'Check the app settings after setup and match the version against the card.',
    'If setup fails, review storage, Android version, and unknown-source permissions first.',
  ],
  section2Intro:
    'Setup is usually quick, but Android permissions and old files can get in the way. These three points cover the checks most users need.',
  section2: [
    [
      'Download GB WhatsApp APK File',
      [
        'Save the package to your Android phone.',
        'Match the version number with the details listed here.',
        'If the transfer stops early, delete the partial file and start again.',
      ],
    ],
    [
      'Enable Unknown Sources',
      [
        'Android may block packages from outside Google Play.',
        'Allow installation for the browser or file manager that holds the APK.',
        'Turn the permission off later if you do not want it left open.',
      ],
    ],
    [
      'Install and Set Up GB WhatsApp',
      [
        'Open the saved file and let Android finish the installer screen.',
        'Launch the app and complete the first-run setup.',
        'Check the installed version in settings when everything opens.',
      ],
    ],
  ],
  section3: [
    'GB WhatsApp is a modified Android messaging app based on WhatsApp. It is distributed as an APK package, so it is installed outside the Google Play Store.',
    'People usually look at it for extra themes, privacy controls, media sharing options, and chat customization. The feature set can change from one build to another, and phone settings may affect how it behaves.',
    'It is not made by WhatsApp or Meta. Treat it as a third-party app, back up important chats, and think carefully before using it on your main phone.',
  ],
  section4Intro:
    'The app is known for customization and extra messaging controls. Feature support can change by release, so treat these cards as a quick overview rather than a promise that every option will appear on every phone.',
  section5: [
    'New releases may bring fixes, compatibility changes, or added options. The version card shows the current listing and its release month.',
    'If your installed build is older, the update page has release notes and backup advice. The entries below give a short view of recent releases.',
    'Previous entries are useful when you want to compare the current build with earlier releases. They are kept as version notes, not as a promise that every old package will remain available.',
  ],
  section6Intro:
    'These answers cover file location, install problems, chat transfer, root access, package conflicts, and account risk. Check the relevant item before changing phone settings or removing an existing app.',
  section7Intro:
    'Use these guides when you need more context than a quick overview. One covers first-time setup, another focuses on updates and chat backups, and the notes explain what changed in the current build.',
}

export const downloadCopy = {
  hero:
    'You are on the GB WhatsApp APK download page. Check the file details below, then use the download button to get the APK through this website download flow.',
  section1: [
    'This page confirms the APK file information before download. It is for users who already want the GB WhatsApp APK and need a clear download step.',
    'Review the app name, file type, platform, latest version, and file size before you continue. After you tap download, wait until the file finishes saving, then open it from Downloads or your notification panel.',
  ],
  section2Intro:
    'Prepare your phone before you install. These checks reduce common install failures and help protect important chat data.',
  installIntro:
    'Use this short overview after the APK is downloaded. Keep the version details from this page nearby while you install.',
}

export const updateCopy = {
  hero:
    'Get the latest GB WhatsApp update information, version details, update steps, and answers to common update questions. This page focuses on GB WhatsApp Update guidance so you can move from an older APK to the newest listed release with care.',
  section1: [
    'The latest GB WhatsApp update listed on this website includes the current version number and release month shown in the update card. Use the download button when you are ready to get the APK through this site download flow.',
    'Always check the version before installing, especially if you already have an older GB WhatsApp APK on your Android phone. Compare the number in the app settings with the version on this page so you know whether an update is needed.',
    'If your phone still has old APK files saved, remove outdated files first. Installing a saved older APK can make the app look updated while the real version remains out of date.',
    'This update page is separate from the homepage so you can focus on version changes, update steps, and update FAQ answers without long feature explanations.',
  ],
  section2Intro:
    'These update highlights describe common areas that new releases may improve. They are short notes for the latest update cycle, not a full long-term feature list. Use them to decide whether the newest release is worth installing now.',
  section3: [
    'Before updating GB WhatsApp, make a backup of important chats from your current app. A backup gives you a safer path if the new APK does not install correctly or if the setup screen asks for data restore.',
    'After backing up, download the new APK file from this website. Open the file and install it over the current version if your device allows that. When the install is complete, open GB WhatsApp and check the app version in settings.',
    'If the update does not work, do not keep trying random APK files. Check your Android version, free storage, and unknown source setting first. Then download the current file again and try one clean install.',
    'Users who need more room for chats and media should free space before updating. Low storage is a common reason an update stops halfway. After a successful install, keep your backup until you confirm chats and media look correct.',
    'If your phone asks you to uninstall first, stop and review your backup. Some package differences require a clean install. In that case, restore chats only after the new version opens correctly.',
  ],
  section4:
    'GB WhatsApp updates do not follow a fixed public schedule. New versions may appear when there are app changes, bug fixes, Android compatibility updates, or new customization options. If you want to know when the next update is available, check this update page and compare your installed version with the latest version shown here. Checking once in a while is enough for most users who only want a stable chat app.',
  section5Intro:
    'Looking for an earlier release instead of the latest update? Visit our GB WhatsApp Old Version page to check previous version numbers, review installation precautions, and find out what to verify before using an older APK.',
  section6Intro:
    'These FAQ items focus on update problems only. For general install questions, open the homepage or download page FAQ sections. Keep this page open while you update so you can check version numbers side by side.',
}

export const footerPages = {
  about: {
    title: 'About Us',
    sections: [
      {
        heading: 'Who We Are',
        paragraphs: [
          `${SITE_BRAND} is an independent GB WhatsApp resource website. We create simple guides, APK information pages, and update notes for users who want to understand GB WhatsApp before downloading or installing it.`,
          'We are not the developers of GB WhatsApp. We are not affiliated with WhatsApp, Meta, or the GB WhatsApp development team. Our role is to organize information in a clear and responsible way so users can make their own decisions.',
          'This website is built for people who already search for GB WhatsApp Download resources and need practical pages, not long marketing articles. We focus on version details, install guidance, and update help.',
        ],
      },
      {
        heading: 'What We Do',
        paragraphs: [
          'Our team follows new GB WhatsApp releases, reviews basic version information, checks common installation steps, and writes guides for Android users. We focus on plain English so users can understand the main points quickly.',
          'We also explain important limits. GB WhatsApp is a modified WhatsApp application, so users should know that it is not an official app and may not work the same way on every device. Feature options can change from one version to another.',
          'When new releases appear, we update the homepage version card, download page details, and update notes where possible. Our goal is to keep the path from information to download clear and easy to follow on mobile and desktop.',
        ],
      },
      {
        heading: 'Our Content Standard',
        paragraphs: [
          'We try to keep content practical, direct, and easy to scan. A download page should help users find file information. An update page should explain version changes. A guide should help users complete one task.',
          'We do not promise that GB WhatsApp is completely safe, official, or risk free. Users should download and install modified apps at their own discretion. We also avoid exaggerated claims about performance or account protection.',
          `If you find outdated details, unclear steps, or a broken page on ${SITE_BRAND}, contact us with the page URL and a short description of the issue. Clear reports help us review and improve the resource faster.`,
        ],
      },
      {
        heading: 'How This Website Helps Users',
        paragraphs: [
          `${SITE_BRAND} brings download confirmation, install preparation, update guidance, and trust pages into one simple site structure. Users can move from the homepage to the download page, then to update notes when a newer version is listed.`,
          'We believe resource pages should feel honest. That means stating that GB WhatsApp is modified, noting that results can vary by device, and reminding users to backup chats before major install or update steps.',
          'Our About page exists so visitors can see who publishes this information and how this site differs from the app developers. Clear identity makes download and update guidance easier to trust.',
        ],
      },
    ],
  },
  contact: {
    title: 'Contact Us',
    sections: [
      {
        heading: 'How to Reach Us',
        paragraphs: [
          `If you have a question about this website, a content correction, or a report about outdated information, you can contact the ${SITE_BRAND} team by email.`,
          `Email: ${SITE_EMAIL}`,
          'Please allow reasonable time for review. We read messages about page errors, unclear install wording, and outdated version details first.',
        ],
      },
      {
        heading: 'Before You Contact Us',
        paragraphs: [
          'Please remember that we are an independent resource website. We do not develop GB WhatsApp, manage user accounts, or provide official WhatsApp support.',
          'For faster review, include the page URL, the issue you found, and the device or Android version if your message is about installation guidance. Screenshots of error text can also help when an install step fails.',
          `If your message is about an account ban, login code, or WhatsApp payment issue, contact the official service provider. ${SITE_BRAND} can only review website content and guide wording.`,
          'We cannot reset WhatsApp accounts, unlock verification codes, or recover chats stored only on your phone. Please use Contact Us for website content issues only.',
        ],
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    sections: [
      {
        heading: 'Introduction',
        paragraphs: [
          `This Privacy Policy explains how ${SITE_BRAND} handles basic information when you visit our website. ${SITE_BRAND} is an independent GB WhatsApp resource site. We provide APK information, update notes, and guides. We do not ask for WhatsApp passwords or private chat content.`,
          'By using this website, you can understand what limited information may be collected for website operation and improvement. If you do not agree with this policy, please stop using the site.',
        ],
      },
      {
        heading: 'Information We Collect',
        paragraphs: [
          `${SITE_BRAND} may collect basic non-personal information when you visit our website. This can include browser type, device type, pages viewed, approximate region, and general usage data.`,
          'If you contact us by email, we may receive your email address and the information you choose to include in your message. We use this only to read and respond to your request.',
          'We do not require an account to browse the homepage, download page, update page, or trust pages. We do not ask users to submit chat backups through this website.',
          'Server logs may also record technical details that help diagnose downtime, page load problems, or unusual traffic. These logs are used for website operation and are not used to build personal marketing profiles.',
        ],
      },
      {
        heading: 'How We Use Information',
        paragraphs: [
          'We use website usage data to understand which pages are helpful, find technical problems, improve page speed, and make our content easier to use on mobile and desktop devices.',
          'We do not sell personal information. We do not ask for WhatsApp account passwords, private chat content, or verification codes. Contact details from email are used only for support related to this website.',
          'When we improve content, we may look at which FAQ items, download sections, or update notes attract the most visits. This helps us write clearer text for future page updates.',
        ],
      },
      {
        heading: 'Cookies and Analytics',
        paragraphs: [
          'This website may use cookies or similar tools to remember basic preferences and measure website traffic. Cookies help us understand how visitors use our pages and which sections need clearer wording.',
          'You can block or delete cookies in your browser settings. Some parts of the website may work differently if cookies are disabled. Analytics tools, when used, help us review visits and page performance over time.',
          'If third-party analytics services are enabled, they may process visit data under their own privacy rules. You can review browser settings and privacy controls for more options.',
        ],
      },
      {
        heading: 'Third-Party Links',
        paragraphs: [
          'Our website may link to other websites for references, guides, or related resources. We are not responsible for the privacy practices, content, or downloads on third-party websites.',
          `Before using another website, read its privacy policy and terms. Leaving ${SITE_BRAND} means your use is controlled by that external website and its own rules.`,
        ],
      },
      {
        heading: 'Data Retention and Your Choices',
        paragraphs: [
          'We keep website logs and contact emails only as long as needed for operation, review, or legal reasons. If you contacted us by email, you can ask us to review the information you sent for that request.',
          'Because this site does not create user accounts, there is no login dashboard for deleting a profile. Browser cookie controls remain the main way to manage local storage on your device.',
        ],
      },
      {
        heading: 'Data Security and Updates',
        paragraphs: [
          'We take reasonable steps to protect the information related to our website. However, no website, server, or internet transfer can be guaranteed to be completely secure.',
          `We may update this Privacy Policy when our website changes. The updated version will be posted on this page with a new update date. Continued use of ${SITE_BRAND} after changes means you have reviewed the latest policy version.`,
          `If you have questions about this Privacy Policy, email ${SITE_EMAIL} with the subject line Privacy Policy so we can review your request more quickly.`,
        ],
      },
    ],
  },
  terms: {
    title: 'Terms of Use',
    sections: [
      {
        heading: 'Use of This Website',
        paragraphs: [
          `By using ${SITE_BRAND}, you agree to use this website for lawful and personal information purposes. The content is provided to help users understand GB WhatsApp APK information, updates, and installation steps.`,
          'You must not misuse this website, attempt to damage its service, copy its content for spam, or use it in a way that harms other users. You also agree not to use the site to spread malware or false install claims.',
        ],
      },
      {
        heading: 'Content Accuracy',
        paragraphs: [
          'We try to keep version information, update notes, and installation guidance clear and current. However, app versions, file details, and Android behavior can change over time.',
          'The content on this website is provided for general information. You should review all details before downloading or installing any APK file. If numbers on your phone differ from page details, trust the install screens on your device and contact us about possible outdated text.',
        ],
      },
      {
        heading: 'Modified App Notice',
        paragraphs: [
          'GB WhatsApp is a modified WhatsApp application. It is not the official WhatsApp app and is not developed by WhatsApp or Meta.',
          `Using a modified app may carry risks, including compatibility problems or account-related issues. You are responsible for your own decision to download, install, or use it. ${SITE_BRAND} does not promise safety, anti-ban results, or uninterrupted service.`,
        ],
      },
      {
        heading: 'External Links and Downloads',
        paragraphs: [
          'Some pages may include links, references, or download resources. We may update, remove, or change these resources when needed.',
          'You agree that you are responsible for checking whether an APK file is suitable for your device and local rules before installation. Keep backups of important chats before major app changes.',
          'Download buttons on this website may use the site download flow. Availability can change when files or linked resources are updated. If a download fails, wait and try again or contact us with the page URL.',
        ],
      },
      {
        heading: 'Intellectual Property',
        paragraphs: [
          `The website layout, written guides, and original page text on ${SITE_BRAND} belong to this resource website unless stated otherwise. Product names and trademarks belong to their owners.`,
          'You may share page links for personal reference. You may not copy large parts of the site content for commercial republication without permission.',
        ],
      },
      {
        heading: 'Limitation of Responsibility',
        paragraphs: [
          `${SITE_BRAND} provides information and guidance pages as an independent resource. We are not liable for device problems, data loss, or account issues that may follow the use of modified apps.`,
          'To the extent allowed by law, this website and its content are provided without warranties of uninterrupted access or perfect accuracy at all times.',
          'Nothing on this website creates a contract for app support, account recovery, or guaranteed install results on every Android phone.',
        ],
      },
      {
        heading: 'Changes to These Terms',
        paragraphs: [
          'We may update these Terms of Use from time to time. Continued use of the website after changes means you accept the updated terms. The latest version will always be shown on this page.',
          'If a major change affects how download or contact features work, we will update the date at the top of this page so users can notice the revision.',
        ],
      },
    ],
  },
  disclaimer: {
    title: 'Disclaimer',
    sections: [
      {
        heading: 'Independent Resource Website',
        paragraphs: [
          `${SITE_BRAND} is an independent information and resource website. We are not the developers of GB WhatsApp, and we are not affiliated with WhatsApp, Meta, or any official WhatsApp team.`,
          'All names, logos, and product references belong to their respective owners. They are used only to identify the topic of our guides and APK information pages. Mentions of GB WhatsApp on this site do not mean ownership or partnership.',
        ],
      },
      {
        heading: 'No Official Support',
        paragraphs: [
          'We do not provide official WhatsApp support, account support, or developer support for GB WhatsApp. If you have a problem with an account or official WhatsApp service, contact the official provider.',
          'Our guides explain common installation and update steps, but they cannot guarantee that every step will work on every device or Android version. Phone brands and system settings can change install behavior.',
        ],
      },
      {
        heading: 'Use at Your Own Discretion',
        paragraphs: [
          'GB WhatsApp is a modified app. Modified apps may carry security, privacy, compatibility, or account risks. We do not claim that GB WhatsApp is completely safe or risk free.',
          'Before downloading or installing any APK file, backup important data and decide whether the app is suitable for your needs. Read version details and install warnings carefully before you continue.',
          `Download and install at your own discretion. ${SITE_BRAND} shares information and guidance, but the final install decision remains with the user.`,
          'Parents and guardians should review install choices for shared devices. Modified messaging apps may not be suitable for every user or every workplace policy.',
        ],
      },
      {
        heading: 'Content Updates',
        paragraphs: [
          'We may update pages when new information is available. Version numbers, file size, features, and installation behavior can change without notice.',
          'If you find outdated or incorrect information on this website, contact us so we can review it. Clear reports with page links help us correct resource pages more quickly.',
        ],
      },
      {
        heading: 'Final Note',
        paragraphs: [
          `By using ${SITE_BRAND}, you understand that this website shares information and download guidance for a modified messaging app. You remain responsible for your install choices and for checking whether GB WhatsApp is appropriate for your device and situation.`,
          'This disclaimer should be read together with our Terms of Use and Privacy Policy. Together, these pages explain how the website works and how it differs from app developers.',
          `If you continue using ${SITE_BRAND} after reading this page, you confirm that you understand the independent nature of this resource website and the limits of the information we publish. Please review these limits before you download or install any APK file.`,
        ],
      },
    ],
  },
}
